/*
 * File: GetStudentCourseEnrollments.ts
 * Author: Austin Robinson
 * Date Created: 8/15/2023
 * Copyright (c) DrivingDoc 2023
 */

import { ErrorResponse, privateApi } from 'api';
import { createQuery } from 'react-query-kit'

export type CountSelfScheduledCoursePeriodsParams = {
    studentId: string;
    courseEnrollmentId: string;
    start: string;
    end: string;
};

export type SelfScheduledPeriodCount = {
    [key: string]: {
        total_course_periods: number;
        course_periods_with_open_performance_slots: number;
        course_periods_with_open_observation_slots: number;
        course_periods_with_open_waitlist_slots: number;
    };
};

async function countSelfScheduledPeriods(params: CountSelfScheduledCoursePeriodsParams) {
    if (!params.studentId || !params.courseEnrollmentId || !params.start || !params.end) {
        return null
    }
    // make api call
    const result = await privateApi.get(`${import.meta.env.VITE_API_BASE_URL}/users/students/${params.studentId}/courseEnrollments/${params.courseEnrollmentId}/countSelfSchedulePeriods`, {
        params: {
            start: params.start,
            end: params.end
        }
    });

    return result.data as SelfScheduledPeriodCount;
}

const useCountSelfScheduledPeriods = createQuery<SelfScheduledPeriodCount | null, CountSelfScheduledCoursePeriodsParams, ErrorResponse>({
    queryKey: ['self_scheduled_course_period_count'],
    fetcher: (variables) => countSelfScheduledPeriods(variables),
});

export { useCountSelfScheduledPeriods };


